import { useAnswerHistoryQuery } from '../../graphql/answer/history';
import { useQuestionAnswerContributorsQuery } from '../../graphql/question/getQuestionAnswerContributors';
export default function useData(questionID) {
    const [historyQueryState, historyQueryActions] = useAnswerHistoryQuery({
        variables: {
            questionID,
        },
    });
    const [answerContributorsQueryState] = useQuestionAnswerContributorsQuery({
        variables: {
            questionID,
        },
    });
    const state = {
        historyQuery: historyQueryState,
        answerContributorsQuery: answerContributorsQueryState,
    };
    const actions = {
        historyQuery: historyQueryActions,
    };
    return [state, actions];
}
